import { createAction, props } from '@ngrx/store';

export const BackItsmSubEntitiesRequested = createAction(
    '[BACK-ITSM] Back Itsm Sub Entities Requested',
    props<{ entityId: string }>()
);
export const BackItsmSubEntitiesSucceded = createAction(
    '[BACK-ITSM] Back Itsm Sub Entities Succeded',
    props<{ subEntities: string[] }>()
);
export const BackItsmSubEntitiesFailed = createAction(
    '[BACK-ITSM] Back Itsm Sub Entities Failed'
);

export const BackItsmSaveSubEntitiesRequested = createAction(
    '[BACK-ITSM] Back Itsm Save Sub Entities Requested',
    props<{ entityId: string, subEntities: string[] }>()
);
export const BackItsmSaveSubEntitiesSucceded = createAction(
    '[BACK-ITSM] Back Itsm Save Sub Entities Succeded',
    props<{ subEntities: string[] }>()
);
export const BackItsmSaveSubEntitiesFailed = createAction(
    '[BACK-ITSM] Back Itsm Save Sub Entities Failed'
);
export const BackItsmSubEntityRemoved = createAction(
    '[BACK-ITSM] Back Itsm Sub Entity Removed',
    props<{ entity: string }>()
);
export const BackItsmSubEntityAdded = createAction(
    '[BACK-ITSM] Back Itsm Sub Entity Added',
    props<{ entity: string }>()
);
export const BackItsmRessourcesRequested = createAction(
    '[BACK-ITSM] Back Itsm Ressources Requested',
    props<{ departmentCode: string }>()
);
export const BackItsmRessourcesSucceeded = createAction(
    '[BACK-ITSM] Back Itsm Ressources Succeeded',
    props<{ ressources: string }>()
);
export const BackItsmRessourcesFailed = createAction(
    '[BACK-ITSM] Back Itsm Ressources Failed'
);